import { Icons, IconTypes } from '@tecton/ComponentRedesign';
import { fcoTypeRecord, FCOType } from '../../core/types/fcoTypes';
import { FcoType } from '../../types/tecton_proto/metadataservice/metadata_service';
import { Workspace } from '@tecton/ComponentRedesign/SharedComponentTypes';
import { ReactNode } from 'react';

export type GlobalSearchItemProps = {
  tabIndex?: number;
  id?: string;
  name?: string;
  owner?: string;
  workspace?: Workspace;
  description?: string;
  lastUpdated?: string;
  materializationOffline?: boolean;
  materializationOnline?: boolean;
  tags?: { key: string; value: string }[];
  type: FcoType | 'ENVIRONMENT';
  group?: string;
  dependencies?: string;
};

export type FcoTypeOrEnvironment = FcoType | 'ENVIRONMENT';

export const GlobalSearchItemTypeRecord: Record<FcoTypeOrEnvironment, string> = {
  ...fcoTypeRecord,
  ENVIRONMENT: 'Environment',
};
export const typeIconMap: Record<FCOType | 'ENVIRONMENT', ReactNode> = {
  [FCOType.DATA_SOURCE]: Icons[IconTypes.SOURCES],
  [FCOType.ENTITY]: Icons[IconTypes.ENTITIES],
  [FCOType.TRANSFORMATION]: Icons[IconTypes.TRANSFORMATIONS],
  [FCOType.FEATURE_VIEW]: Icons[IconTypes.FEATURE_VIEWS],
  [FCOType.FEATURE_SERVICE]: Icons[IconTypes.FEATURE_SERVICE],
  [FCOType.DATASET]: Icons[IconTypes.DATASET],
  ENVIRONMENT: Icons[IconTypes.ENVIRONMENT],
  [FCOType.UNKNOWN]: <></>,
};
